import React from 'react';
import { Grid, GridProps } from '@mui/material';
import useWindowDimensions from '../../hooks/useWindowDimensions';

interface PageContentWithBackgroundProps extends GridProps {
  centeredContent?: boolean;
}

export const PageContentWithBackground: React.FC<PageContentWithBackgroundProps> = ({
  className = 'page-content-with-background',
  centeredContent,
  ...props
}) => {
  const { width } = useWindowDimensions();

  return (
    <Grid
      className={className}
      {...props}
      sx={{
        position: 'relative',
        justifyItems: centeredContent ? 'center' : undefined,
        display: centeredContent ? (width > 1500 ? 'grid' : undefined) : undefined,
        ...props.style,
        ...props.sx,
      }}>
      {props.children}
    </Grid>
  );
};
